var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.specificInfoLog,{tag:"component",attrs:{"logInfo":_vm.logData,"detail":_vm.detail}})
}
var staticRenderFns = []

export { render, staticRenderFns }